module.exports = __webpack_public_path__ + "static/media/pti.e76e7438.jpg";